import { StrokePoint } from '@/models/StrokePoint'
export class CanvasUtils {
  public static caliculatePosition(e: TouchEvent | MouseEvent, canvasElement: HTMLCanvasElement): StrokePoint {
    const clientRect = canvasElement.getBoundingClientRect()
    if (e instanceof MouseEvent) {
      // PC用(マウスイベント)の処理
      return {
        x: e.offsetX,
        y: e.offsetY,
      }
    } else {
      // スマホ用(タッチイベント)の処理
      return {
        x: e.touches[0].pageX - clientRect.left,
        y: e.touches[0].pageY - clientRect.top,
      }
    }
  }

  /**
   * キャンバスサイズが不一致
   */
  public static canvasSizeMismatch(canvasArea: HTMLElement, canvasElement: HTMLCanvasElement): boolean {
    // ラッパーdivタグのサイズがキャンバスサイズと一致していない
    return canvasArea.offsetWidth !== canvasElement.width || canvasArea.offsetHeight !== canvasElement.height
  }
}
